






import {Component, Vue} from 'vue-property-decorator';

@Component
export default class DialogBox extends Vue {

  userDecided(result: boolean) {
    this.$emit(('close'), result);
  }

  keyUpEvent(event: KeyboardEvent) {
    switch (event.key) {
      case 'Escape': {
        this.userDecided(false);
        break;
      }
      default: {
        break;
      }
    }
  }

  mounted() {
    document.addEventListener('keyup', this.keyUpEvent);
    const overlayEl = this.$refs.dialogOverlay as HTMLElement;
    if (overlayEl) {
      overlayEl.focus();
    }
  }

  beforeDestroy() {
    document.removeEventListener('keyup', this.keyUpEvent);
  }

}
